// source: sceneview/protos/domain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var core_protos_geometry_pb = require('../../core/protos/geometry_pb.js');
goog.object.extend(proto, core_protos_geometry_pb);
var core_protos_instant_pb = require('../../core/protos/instant_pb.js');
goog.object.extend(proto, core_protos_instant_pb);
var core_protos_material_pb = require('../../core/protos/material_pb.js');
goog.object.extend(proto, core_protos_material_pb);
var core_protos_representation_pb = require('../../core/protos/representation_pb.js');
goog.object.extend(proto, core_protos_representation_pb);
var core_protos_uuid_pb = require('../../core/protos/uuid_pb.js');
goog.object.extend(proto, core_protos_uuid_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyCategory', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyEntry', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyKey', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyValue', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyValue.SealedValueOptionalCase', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.PropertyValueString', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride', null, global);
goog.exportSymbol('proto.vertexvis.protobuf.sceneview.v1.SceneViewItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.displayName = 'proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.SceneViewItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.displayName = 'proto.vertexvis.protobuf.sceneview.v1.SceneViewItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.displayName = 'proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyKey.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyKey';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyValueString, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyValueString';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyValue.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vertexvis.protobuf.sceneview.v1.PropertyEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.displayName = 'proto.vertexvis.protobuf.sceneview.v1.PropertyEntry';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_representation_pb.RepresentationId.toObject(includeInstance, f),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isApplied: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation;
  return proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_representation_pb.RepresentationId;
      reader.readMessage(value,core_protos_representation_pb.RepresentationId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsApplied(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_representation_pb.RepresentationId.serializeBinaryToWriter
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsApplied();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional vertexvis.protobuf.core.RepresentationId id = 1;
 * @return {?proto.vertexvis.protobuf.core.RepresentationId}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.RepresentationId} */ (
    jspb.Message.getWrapperField(this, core_protos_representation_pb.RepresentationId, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.RepresentationId|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_applied = 3;
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.getIsApplied = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.ItemRepresentation.prototype.setIsApplied = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    suppliedId: (f = msg.getSuppliedId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    parentId: (f = msg.getParentId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    name: (f = msg.getName()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && core_protos_instant_pb.Instant.toObject(includeInstance, f),
    boundingBox: (f = msg.getBoundingBox()) && core_protos_geometry_pb.BoundingBox3f.toObject(includeInstance, f),
    override: (f = msg.getOverride()) && proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.toObject(includeInstance, f),
    worldTransform: (f = msg.getWorldTransform()) && core_protos_geometry_pb.Matrix4x4f.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.SceneViewItem;
  return proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSuppliedId(value);
      break;
    case 3:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setParentId(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setName(value);
      break;
    case 5:
      var value = new core_protos_instant_pb.Instant;
      reader.readMessage(value,core_protos_instant_pb.Instant.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = new core_protos_geometry_pb.BoundingBox3f;
      reader.readMessage(value,core_protos_geometry_pb.BoundingBox3f.deserializeBinaryFromReader);
      msg.setBoundingBox(value);
      break;
    case 7:
      var value = new proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.deserializeBinaryFromReader);
      msg.setOverride(value);
      break;
    case 8:
      var value = new core_protos_geometry_pb.Matrix4x4f;
      reader.readMessage(value,core_protos_geometry_pb.Matrix4x4f.deserializeBinaryFromReader);
      msg.setWorldTransform(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getSuppliedId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getParentId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getName();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      core_protos_instant_pb.Instant.serializeBinaryToWriter
    );
  }
  f = message.getBoundingBox();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      core_protos_geometry_pb.BoundingBox3f.serializeBinaryToWriter
    );
  }
  f = message.getOverride();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.serializeBinaryToWriter
    );
  }
  f = message.getWorldTransform();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      core_protos_geometry_pb.Matrix4x4f.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue supplied_id = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getSuppliedId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setSuppliedId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearSuppliedId = function() {
  return this.setSuppliedId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasSuppliedId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional vertexvis.protobuf.core.Uuid2l parent_id = 3;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getParentId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setParentId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearParentId = function() {
  return this.setParentId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasParentId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.StringValue name = 4;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getName = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 4));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setName = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearName = function() {
  return this.setName(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional vertexvis.protobuf.core.Instant created_at = 5;
 * @return {?proto.vertexvis.protobuf.core.Instant}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Instant} */ (
    jspb.Message.getWrapperField(this, core_protos_instant_pb.Instant, 5));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Instant|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional vertexvis.protobuf.core.BoundingBox3f bounding_box = 6;
 * @return {?proto.vertexvis.protobuf.core.BoundingBox3f}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getBoundingBox = function() {
  return /** @type{?proto.vertexvis.protobuf.core.BoundingBox3f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.BoundingBox3f, 6));
};


/**
 * @param {?proto.vertexvis.protobuf.core.BoundingBox3f|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setBoundingBox = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearBoundingBox = function() {
  return this.setBoundingBox(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasBoundingBox = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SceneItemOverride override = 7;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getOverride = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride, 7));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setOverride = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearOverride = function() {
  return this.setOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasOverride = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional vertexvis.protobuf.core.Matrix4x4f world_transform = 8;
 * @return {?proto.vertexvis.protobuf.core.Matrix4x4f}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.getWorldTransform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Matrix4x4f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Matrix4x4f, 8));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Matrix4x4f|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.setWorldTransform = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneViewItem} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.clearWorldTransform = function() {
  return this.setWorldTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneViewItem.prototype.hasWorldTransform = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && core_protos_uuid_pb.Uuid2l.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && core_protos_instant_pb.Instant.toObject(includeInstance, f),
    transform: (f = msg.getTransform()) && core_protos_geometry_pb.Matrix4x4f.toObject(includeInstance, f),
    isVisible: (f = msg.getIsVisible()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    isSelected: (f = msg.getIsSelected()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    isPhantom: (f = msg.getIsPhantom()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    endItem: (f = msg.getEndItem()) && google_protobuf_wrappers_pb.BoolValue.toObject(includeInstance, f),
    materialOverride: (f = msg.getMaterialOverride()) && core_protos_material_pb.MaterialOverride.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride;
  return proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new core_protos_uuid_pb.Uuid2l;
      reader.readMessage(value,core_protos_uuid_pb.Uuid2l.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new core_protos_instant_pb.Instant;
      reader.readMessage(value,core_protos_instant_pb.Instant.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = new core_protos_geometry_pb.Matrix4x4f;
      reader.readMessage(value,core_protos_geometry_pb.Matrix4x4f.deserializeBinaryFromReader);
      msg.setTransform(value);
      break;
    case 4:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsVisible(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsSelected(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setIsPhantom(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.BoolValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.BoolValue.deserializeBinaryFromReader);
      msg.setEndItem(value);
      break;
    case 8:
      var value = new core_protos_material_pb.MaterialOverride;
      reader.readMessage(value,core_protos_material_pb.MaterialOverride.deserializeBinaryFromReader);
      msg.setMaterialOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      core_protos_uuid_pb.Uuid2l.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      core_protos_instant_pb.Instant.serializeBinaryToWriter
    );
  }
  f = message.getTransform();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      core_protos_geometry_pb.Matrix4x4f.serializeBinaryToWriter
    );
  }
  f = message.getIsVisible();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsSelected();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getIsPhantom();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getEndItem();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.BoolValue.serializeBinaryToWriter
    );
  }
  f = message.getMaterialOverride();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      core_protos_material_pb.MaterialOverride.serializeBinaryToWriter
    );
  }
};


/**
 * optional vertexvis.protobuf.core.Uuid2l id = 1;
 * @return {?proto.vertexvis.protobuf.core.Uuid2l}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getId = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Uuid2l} */ (
    jspb.Message.getWrapperField(this, core_protos_uuid_pb.Uuid2l, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Uuid2l|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional vertexvis.protobuf.core.Instant created_at = 2;
 * @return {?proto.vertexvis.protobuf.core.Instant}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getCreatedAt = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Instant} */ (
    jspb.Message.getWrapperField(this, core_protos_instant_pb.Instant, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Instant|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional vertexvis.protobuf.core.Matrix4x4f transform = 3;
 * @return {?proto.vertexvis.protobuf.core.Matrix4x4f}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getTransform = function() {
  return /** @type{?proto.vertexvis.protobuf.core.Matrix4x4f} */ (
    jspb.Message.getWrapperField(this, core_protos_geometry_pb.Matrix4x4f, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.core.Matrix4x4f|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setTransform = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearTransform = function() {
  return this.setTransform(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasTransform = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.BoolValue is_visible = 4;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getIsVisible = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 4));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setIsVisible = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearIsVisible = function() {
  return this.setIsVisible(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasIsVisible = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.BoolValue is_selected = 5;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getIsSelected = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 5));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setIsSelected = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearIsSelected = function() {
  return this.setIsSelected(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasIsSelected = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.BoolValue is_phantom = 6;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getIsPhantom = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 6));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setIsPhantom = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearIsPhantom = function() {
  return this.setIsPhantom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasIsPhantom = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.BoolValue end_item = 7;
 * @return {?proto.google.protobuf.BoolValue}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getEndItem = function() {
  return /** @type{?proto.google.protobuf.BoolValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.BoolValue, 7));
};


/**
 * @param {?proto.google.protobuf.BoolValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setEndItem = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearEndItem = function() {
  return this.setEndItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasEndItem = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional vertexvis.protobuf.core.MaterialOverride material_override = 8;
 * @return {?proto.vertexvis.protobuf.core.MaterialOverride}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.getMaterialOverride = function() {
  return /** @type{?proto.vertexvis.protobuf.core.MaterialOverride} */ (
    jspb.Message.getWrapperField(this, core_protos_material_pb.MaterialOverride, 8));
};


/**
 * @param {?proto.vertexvis.protobuf.core.MaterialOverride|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.setMaterialOverride = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.clearMaterialOverride = function() {
  return this.setMaterialOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.SceneItemOverride.prototype.hasMaterialOverride = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.toObject = function(includeInstance, msg) {
  var f, obj = {
    category: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyKey;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.vertexvis.protobuf.sceneview.v1.PropertyCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategory();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional PropertyCategory category = 1;
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyCategory}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.prototype.getCategory = function() {
  return /** @type {!proto.vertexvis.protobuf.sceneview.v1.PropertyCategory} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyCategory} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.prototype.setCategory = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyKey} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyKey.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueString} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueString}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueString;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueString} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueString}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueString} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueString} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
};


/**
 * optional sint64 value = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double value = 1;
 * @return {number}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp value = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.prototype.getValue = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.SealedValueOptionalCase = {
  SEALED_VALUE_OPTIONAL_NOT_SET: 0,
  STRING: 1,
  LONG: 2,
  DOUBLE: 3,
  DATE: 4
};

/**
 * @return {proto.vertexvis.protobuf.sceneview.v1.PropertyValue.SealedValueOptionalCase}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.getSealedValueOptionalCase = function() {
  return /** @type {proto.vertexvis.protobuf.sceneview.v1.PropertyValue.SealedValueOptionalCase} */(jspb.Message.computeOneofCase(this, proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    string: (f = msg.getString()) && proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.toObject(includeInstance, f),
    pb_long: (f = msg.getLong()) && proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.toObject(includeInstance, f),
    pb_double: (f = msg.getDouble()) && proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.toObject(includeInstance, f),
    date: (f = msg.getDate()) && proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyValue;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueString;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.deserializeBinaryFromReader);
      msg.setString(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.deserializeBinaryFromReader);
      msg.setLong(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.deserializeBinaryFromReader);
      msg.setDouble(value);
      break;
    case 4:
      var value = new proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getString();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.vertexvis.protobuf.sceneview.v1.PropertyValueString.serializeBinaryToWriter
    );
  }
  f = message.getLong();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong.serializeBinaryToWriter
    );
  }
  f = message.getDouble();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble.serializeBinaryToWriter
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate.serializeBinaryToWriter
    );
  }
};


/**
 * optional PropertyValueString string = 1;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueString}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.getString = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.PropertyValueString} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.PropertyValueString, 1));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueString|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.setString = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.clearString = function() {
  return this.setString(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.hasString = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PropertyValueLong long = 2;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.getLong = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueLong|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.setLong = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.clearLong = function() {
  return this.setLong(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.hasLong = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PropertyValueDouble double = 3;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.getDouble = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueDouble|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.setDouble = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.clearDouble = function() {
  return this.setDouble(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.hasDouble = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PropertyValueDate date = 4;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.getDate = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate, 4));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.PropertyValueDate|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.setDate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.vertexvis.protobuf.sceneview.v1.PropertyValue.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyValue} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyValue.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    key: (f = msg.getKey()) && proto.vertexvis.protobuf.sceneview.v1.PropertyKey.toObject(includeInstance, f),
    value: (f = msg.getValue()) && proto.vertexvis.protobuf.sceneview.v1.PropertyValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vertexvis.protobuf.sceneview.v1.PropertyEntry;
  return proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.vertexvis.protobuf.sceneview.v1.PropertyKey;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.PropertyKey.deserializeBinaryFromReader);
      msg.setKey(value);
      break;
    case 3:
      var value = new proto.vertexvis.protobuf.sceneview.v1.PropertyValue;
      reader.readMessage(value,proto.vertexvis.protobuf.sceneview.v1.PropertyValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getKey();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.vertexvis.protobuf.sceneview.v1.PropertyKey.serializeBinaryToWriter
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.vertexvis.protobuf.sceneview.v1.PropertyValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PropertyKey key = 2;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.PropertyKey}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.getKey = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.PropertyKey} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.PropertyKey, 2));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.PropertyKey|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.setKey = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.clearKey = function() {
  return this.setKey(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.hasKey = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PropertyValue value = 3;
 * @return {?proto.vertexvis.protobuf.sceneview.v1.PropertyValue}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.getValue = function() {
  return /** @type{?proto.vertexvis.protobuf.sceneview.v1.PropertyValue} */ (
    jspb.Message.getWrapperField(this, proto.vertexvis.protobuf.sceneview.v1.PropertyValue, 3));
};


/**
 * @param {?proto.vertexvis.protobuf.sceneview.v1.PropertyValue|undefined} value
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} returns this
*/
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vertexvis.protobuf.sceneview.v1.PropertyEntry} returns this
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyEntry.prototype.hasValue = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.vertexvis.protobuf.sceneview.v1.PropertyCategory = {
  PROPERTY_CATEGORY_INVALID: 0,
  PROPERTY_CATEGORY_USER: 1,
  PROPERTY_CATEGORY_VERTEX: 2,
  PROPERTY_CATEGORY_VENDOR: 3
};

goog.object.extend(exports, proto.vertexvis.protobuf.sceneview.v1);
